import { EnrollmentRepository } from '@/application/shared/domain/EnrollmentRepository';
import { UseCase } from '@/shared/application/UseCase';
import { SfApiResponse } from '@hfc/ui-core';
import { FeedbackInfo } from '@/application/shared/domain/FeedbackInfo';
import { APPLICATION_TYPES } from '@hfc/common/src/types/ApplicationTypes';
import { UUID } from '@hfc/common/src/types/UUID';

export class SendApplicationFeedbackUseCase implements UseCase<[FeedbackInfo, APPLICATION_TYPES, UUID, string?], SfApiResponse> {

  private repository: EnrollmentRepository;

  public constructor (repository: EnrollmentRepository) {
    this.repository = repository;
  }

  public async run (params: [FeedbackInfo, APPLICATION_TYPES, UUID, string?]): Promise<SfApiResponse> {
    const [feedbackInfo, applicationType, uuid, token] = params;

    return await this.repository.sendApplicationFeedback(feedbackInfo, applicationType, uuid, token);
  }

}
